

import { NestedFilterExtractionProperty, NestedFilterExtractorUtil } from '../utils/nested-filter-extractor.util';
import { StoreColumnExtractor } from './store-column-extractor';


/**
 * This extractor is for when you need to get a value from inside nested arrays
 * It traverses through arrays to get to the final value using property comparisons to find which element of each array you need.
 * It's like the StoreFilterExtractor but...better :)
 * 
 * Check out the tests to see how to use it!
 */
export class StoreNestedFilterExtractor implements StoreColumnExtractor {
	constructor(
		public readonly storeConfig: any[],
		public readonly seriesExpression: string, // path to series object, for example 'sleeves.equity.breakdowns.region.sectors'
		// The more elements in this list, the deeper this extractor will go... Example: [{propertyToCompare: 'name', comparedValue: 'notReal', desiredValueExpression: 'contribution'}]
		public readonly properties: NestedFilterExtractionProperty[],
		public readonly defaultValue?: number
	) { }
	public storeConfigDependencies(): any[] {
		return this.storeConfig;
	}
	public extractor(): (storeData: any[]) => any {
		return (storeData: any[]) => NestedFilterExtractorUtil.extractNestedProperty(storeData, this.seriesExpression, this.properties, this.defaultValue);
	}

	public getDataPointPath(): string {
		const dataPath = this.storeConfig.length > 0 ? this.storeConfig[0] + ' ' + this.seriesExpression : this.seriesExpression;
		return dataPath;
	}
}
